import React, { ReactElement, useContext, useState } from "react"
import Spreadsheet from "react-spreadsheet"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye } from "@fortawesome/free-solid-svg-icons"

import { Modal } from "@wfp/ui"

import { DataUploadContext } from "../../../../providers/DataUploadContext"
import { MappingPriceContext } from "../../../../providers/MappingPricesContext"

type Props = {
  title: string
  descriptions: string[]
}

const MappingStepHeader = ({ title, descriptions }: Props): ReactElement => {
  const { sheetData, fileName } = useContext(MappingPriceContext)
  const { filters } = useContext(DataUploadContext)

  const [showPreview, setShowPreview] = useState<boolean>(false)

  const text = filters.file?.name || fileName || "N/A"

  return (
    <div>
      <div>
        <div className="flex gap-x-6 mb-1 items-baseline text-justify">
          <h4>{title}</h4>
          <div className="flex gap-x-2 items-center">
            <p className="text-sm truncate max-w-[300px]">{text}</p>
            <FontAwesomeIcon
              icon={faEye}
              color="var(--interactive-01)"
              size="sm"
              className="cursor-pointer p-0.5"
              title="Preview"
              onClick={() => setShowPreview(true)}
            />
          </div>
        </div>

        {descriptions.map((description, index) => (
          <p key={index} className="text-sm">
            {description}
          </p>
        ))}
      </div>

      <Modal
        lazyLoad
        open={showPreview && !!sheetData && sheetData?.length > 0}
        modalHeading="Preview"
        modalLabel={text}
        onRequestClose={() => setShowPreview(false)}
        passiveModal
        wide
      >
        <div className="max-h-[470px] overflow-auto min-w-[200px] relative max-w-full">
          <Spreadsheet data={sheetData ?? []} className="compact-table" />
        </div>
      </Modal>
    </div>
  )
}

export default MappingStepHeader
